// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__crtEA","content":"styles_content__1kE-F","selectAll":"styles_selectAll__KGreW"};